<template>
  <div class="content">
    <div class="page-inner">
      <div class="page-header" v-if="!application">
        <h4 class="page-title">{{ $t('labels') }}</h4>
        <ul class="breadcrumbs">
          <li class="nav-home">
            <router-link to="/dashboard">
              <i class="flaticon-home"></i>
            </router-link>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <router-link to="/labels">{{ $t('labels') }}</router-link>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <a href="#" v-if="!label._id">{{ $t('new_label') }}</a>
            <a href="#" v-if="label._id">{{ label.name }}</a>
          </li>
        </ul>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title" v-if="!label._id">{{ $t('new_label') }}</div>
              <div class="card-title" v-if="label._id">{{ label.name }}</div>
              <div class="card-category">{{ $t('fill_all_required') }}</div>
            </div>
            <form @submit.prevent="submitLabel()">
              <div class="card-body">
                <div class="form-group form-show-validation row">
                  <label for="label-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    {{ $t('label_name') }}
                    <span class="required-label">*</span>
                  </label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <input
                      type="text"
                      v-model="label.name"
                      class="form-control"
                      id="label-name"
                      name="name"
                      placeholder
                      required
                      :readonly="label._id"
                    />
                    <small
                      class="form-text text-danger"
                      v-if="!label._id"
                    >{{ $t('do_not_use_emojis') }}</small>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="label-holder" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    {{ $t('copyright_holder') }}
                  </label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <input
                      type="text"
                      v-model="label.copyright_holder"
                      class="form-control"
                      id="label-holder"
                      name="copyright-holder"
                      :placeholder="`${label.name || 'Indiefy Inc.'}`"
                    />
                    <span class="form-text text-small">
                      {{ $t('copyright_line_description') }}
                    </span>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    {{ $t('main_genre') }}
                    <span class="required-label">*</span>
                  </label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="select2-input">
                      <Select2 v-model="label.main_genre" :options="genres"></Select2>
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row" v-if="showBeatportInputs">
                  <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    {{ $t('beatport_delivery_required') }}
                  </label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                      <div class="input-group">
                        <ul class="nav nav-pills nav-primary">
                          <li class="nav-item">
                            <a
                              class="nav-link my-0"
                              :class="{ active: label.beatport_delivery.profile }"
                              href="javascript:void(0)"
                              @click="setBeatportProfile(true)">
                              {{ $t('yes') }}
                            </a>
                          </li>
                          <li class="nav-item">
                            <a
                              class="nav-link my-0"
                              :class="{ active: !label.beatport_delivery.profile }"
                              @click="setBeatportProfile(false)"
                              href="javascript:void(0)"
                            >{{ $t('no') }}</a>
                          </li>
                        </ul>
                      </div>
                  </div>
                </div>
                <div v-show="label.beatport_delivery.profile">
                  <div class="form-group form-show-validation row">
                    <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                      {{ $t('upload_beatport_profile_image') }}
                      <span class="required-label">*</span>
                    </label>
                    <div class="col-lg-4 col-md-9 col-sm-8">
                      <div class="input-file input-file-image" v-if="label.beatport_delivery.image_full">
                        <img :src="label.beatport_delivery.image_full" alt width="200" class="img-thumbnail" />
                        <br />
                        <button
                          type="button"
                          class="mt-2 btn btn-default btn-sm"
                          @click="validateImageToRemove(false)"
                        >{{ $t('remove_image') }}</button>
                      </div>
                      <div class="input-file input-file-image" v-show="!label.beatport_delivery.image_full">
                        <croppa
                          :width="200"
                          :height="200"
                          :prevent-white-space="true"
                          v-model="beatportProfileImg"
                          @file-choose="handleBeatportImageChoose"
                        ></croppa>
                        <span class="form-text text-small mt-0">
                          {{ $t('image_size_1000x1000') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-show-validation row">
                    <label for="label-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                      {{ $t('beatport_label_name') }}
                    </label>
                    <div class="col-lg-4 col-md-9 col-sm-8">
                      <input
                        type="text"
                        v-model="label.name"
                        class="form-control"
                        id="label-name"
                        name="name"
                        placeholder
                        required
                        :readonly="true"
                      />
                    </div>
                  </div>
                </div>
                <div class="separator-solid"></div>
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    {{ $t('website') }}
                    <span class="required-label"></span>
                  </label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <input
                        type="url"
                        class="form-control"
                        v-model="label.website"
                        placeholder="https://"
                        aria-label="website"
                        name="website"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    Instagram
                    <span class="required-label"></span>
                  </label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="instagram-addon">@</span>
                      </div>
                      <input
                        type="text"
                        v-model="label.instagram"
                        class="form-control"
                        placeholder
                        aria-label="instagram"
                        aria-describedby="instagram-addon"
                        name="instagram"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    Twitter
                    <span class="required-label"></span>
                  </label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="twitter-addon">@</span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        v-model="label.twitter"
                        placeholder
                        aria-label="twitter"
                        aria-describedby="twitter-addon"
                        name="twitter"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    Soundcloud
                    <span class="required-label"></span>
                  </label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="soundcloud-addon">soundcloud.com/</span>
                      </div>
                      <input
                        type="text"
                        v-model="label.soundcloud"
                        class="form-control"
                        placeholder
                        aria-label="soundcloud"
                        aria-describedby="soundcloud-addon"
                        name="soundcloud"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    {{ $t('facebook_page') }}
                    <span class="required-label"></span>
                  </label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="facebook-addon">facebook.com/</span>
                      </div>
                      <input
                        type="text"
                        v-model="label.facebook"
                        class="form-control"
                        placeholder
                        aria-label="facebook"
                        aria-describedby="facebook-addon"
                        name="facebook"
                      />
                    </div>
                  </div>
                </div>
                <div class="separator-solid"></div>
                <div class="form-group form-show-validation row">
                  <label
                    class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right"
                  >{{ $t('label_image') }}</label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-file input-file-image" v-if="label.cover_image">
                      <img :src="label.cover_image" alt width="200" class="img-thumbnail" />
                      <br />
                      <button
                        type="button"
                        class="mt-2 btn btn-default btn-sm"
                        @click="validateImageToRemove(true)"
                      >{{ $t('remove_image') }}</button>
                    </div>
                    <div class="input-file input-file-image" v-show="!label.cover_image">
                      <croppa
                        :width="300"
                        :height="300"
                        :prevent-white-space="true"
                        v-model="myCroppa"
                      ></croppa>
                      <div class="mt-sm">
                        <button
                          class="btn btn-default btn-sm"
                          type="button"
                          @click="zoomOut()"
                          :disabled="!hasFile"
                        >
                          <i class="fa fa-search-minus"></i>
                        </button>
                        <button
                          class="btn btn-default btn-sm"
                          type="button"
                          @click="zoomIn()"
                          :disabled="!hasFile"
                        >
                          <i class="fa fa-search-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-action">
                <div class="row">
                  <div class="col-md-12">
                    <router-link to="/dashboard" tag="button" class="btn btn-default btn-border no-border" :disabled="saving">
                      {{ $t('cancel') }}
                    </router-link>
                    <button class="btn btn-success" type="submit" :disabled="saving">
                      <span v-if="saving" class="fa fa-spinner fa-spin"></span>
                      <span v-if="!saving">{{ $t('save') }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import Labels from '../services/labels'
import Select2 from './utils/Select2'
import Upload from '../services/upload'
import genres from '../data/genres'

export default {
  name: 'LabelEditor',
  props: ['application'],
  data: function () {
    return {
      saving: false,
      genres: _.map(genres, (genre, key) => {
        return key
      }),
      label: {
        beatport_delivery: {
          profile: false,
          image_full: ''
        }
      },
      myCroppa: {},
      beatportProfileImg: {},
      selectedImage: '',
      beatportGenres: [
        'Dance',
        'Electronic',
        'Hip Hop/Rap',
        'Reggae',
        'R&B/Soul'
      ],
      showBeatportInputs: false,
      labelProfileImage: false,
      beatportProfileImage: false
    }
  },
  computed: {
    hasFile: function () {
      return this.myCroppa.getChosenFile && this.myCroppa.getChosenFile()
    },
    hasBeatportProfileFile: function () {
      return this.beatportProfileImg.getChosenFile && this.beatportProfileImg.getChosenFile()
    }
  },
  methods: {
    validateImageToRemove: function (isProfileImage) {
      if (isProfileImage) {
        this.removeProfileImage()
      } else {
        this.removeBeatportImage()
      }
    },
    removeProfileImage: function () {
      Upload.removeImage(
        this.label.cover_image.split('/').pop(),
        'label-images'
      ).then(response => {
        this.label.cover_image = ''

        if (this.label._id) {
          this.saveLabel()
        }
      })
    },
    removeBeatportImage: function () {
      Upload.removeImage(
        this.label.beatport_delivery.image_full.split('/').pop(),
        'beatport-images'
      ).then(response => {
        this.label.beatport_delivery = {
          profile: false,
          image_full: ''
        }

        if (this.label._id) {
          this.saveLabel()
        }
      })
    },
    zoomIn: function () {
      this.myCroppa.zoomIn()
    },
    zoomOut: function () {
      this.myCroppa.zoomOut()
    },
    saveLabel: function () {
      this.saving = true

      if (this.application) {
        this.label.status = 0
        this.label.application = 1
      }

      Labels.save(this.label)
        .then(response => {
          this.saving = false
          this.$notify({ message: this.$t('label_saved') }, 'success', 'fa-check')

          if (this.application) {
            this.$router.push('/labels')
          } else {
            this.$router.push('/dashboard')
          }
        })
        .catch(err => {
          this.saving = false
          let error = err.response.data.name

          if (error === 'already_exists') {
            this.$notify(
              { message: this.$t('name_already_exists') },
              'danger',
              'fa-exclamation'
            )
          }
        })
    },
    submitLabel: function () {
      if (!this.label.name) {
        return this.$notify({ message: this.$t('type_name') }, 'warning', 'fa-exclamation')
      }

      if (!this.label.main_genre) {
        return this.$notify({ message: this.$t('main_genre_required') }, 'warning', 'fa-exclamation')
      }

      if (this.label.beatport_delivery.profile && this.beatportProfileImg.getChosenFile && !this.beatportProfileImg.getChosenFile() && !this.label.beatport_delivery.image_full) {
        return this.$notify({ message: this.$t('no_beatport_image') }, 'warning', 'fa-exclamation')
      }

      this.saving = true

      if (!this.label.beatport_delivery.profile) {
        this.label.beatport_delivery = {
          profile: false,
          image_full: ''
        }
      }

      let uploadProfileImage = false
      let uploadBeatportImage = false

      if (this.myCroppa.getChosenFile && this.myCroppa.getChosenFile()) {
        uploadProfileImage = true
      }

      if (this.beatportProfileImg.getChosenFile && this.beatportProfileImg.getChosenFile()) {
        uploadBeatportImage = true
      }

      if (uploadProfileImage) {
        this.uploadProfileImage(() => {
          if (uploadBeatportImage) {
            this.uploadBeatportImage(() => {
              this.saveLabel()
            })
          } else {
            this.saveLabel()
          }
        })
      } else if (uploadBeatportImage) {
        this.uploadBeatportImage(() => {
          this.saveLabel()
        })
      } else {
        this.saveLabel()
      }
    },
    showBeatportProfile: function () {
      let file = this.$refs.beatportImageFile
      if (file.files[0]) {
        this.checkImageSize(file.files[0], isValid => {
          if (!isValid) {
            this.uploading = false
            return this.$notify({ message: this.$t('beatport_profile_image_sizes') }, 'warning', 'fa fa-exclamation')
          }
        })
      }
    },
    uploadProfileImage: function (callback) {
      this.myCroppa.generateBlob(
        blob => {
          Upload.uploadImage(blob, 'label-images').then(response => {
            this.label.cover_image = response.data.full
            this.label.cover_image_small = response.data.small

            if (callback) {
              callback()
            }
          })
        },
        'image/jpeg',
        0.8
      ) // 80% compressed jpeg file
    },
    uploadBeatportImage: function (callback) {
      this.beatportProfileImg.generateBlob(
        blob => {
          Upload.uploadImage(blob, 'beatport-images').then(response => {
            this.label.beatport_delivery.image_full = response.data.full

            if (callback) {
              callback()
            }
          })
        },
        'image/jpeg',
        0.8
      ) // 80% compressed jpeg file
    },
    checkImageSize: function (file, _callback) {
      let _URL =
        window.URL || window.webkitURL || window.mozURL || window.msURL
      let img

      if (file) {
        img = new Image()
        img.onload = function () {
          if (this.width === 1000 && this.width === 1000) {
            if (this.width === this.height) {
              _callback(true)
            } else {
              _callback(false)
            }
          } else {
            _callback(false)
          }
        }
        img.src = _URL.createObjectURL(file)
      } else {
        _callback(false)
      }
    },
    handleBeatportImageChoose: function (file) {
      if (file) {
        this.checkImageSize(file, isValid => {
          if (!isValid) {
            this.uploading = false
            return this.$notify({ message: this.$t('beatport_profile_image_sizes') }, 'warning', 'fa fa-exclamation')
          }
        })
      }
    },
    setBeatportProfile: function (value) {
      this.label.beatport_delivery.profile = value
      this.$forceUpdate()
    }
  },
  created: function () {
    this.user = this.$user

    if (this.user.freeze) {
      this.$notify({ message: this.$t('freeze_user_message') }, 'warning', 'fa-exclamation')
      return this.$router.push('/labels')
    }

    if (this.$route.params.id) {
      Labels.get(this.$route.params.id).then(response => {
        this.label = response.data
        if (!this.label.beatport_delivery) {
          this.label.beatport_delivery = {
            profile: false,
            image_full: ''
          }
        }
      })
    }
  },
  mounted: function () {},
  components: {
    Select2
  },
  watch: {
    'label.main_genre': function (val, oldVal) {
      this.showBeatportInputs = _.find(this.beatportGenres, (value) => {
        return val === value
      })
    }
  }
}
</script>
<style lang='scss' scoped>
#label-image {
  width: 200px;
  height: 200px;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/LabelEditor.vue